import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const sendCostsToLec = (centerId: number) => {
  return restApiClient
    .url(constructApiUrl(API.centers.sendCostsToLec.url, { id: centerId }))
    .post()
}
